/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { PaymentSplitDtoV2 } from './PaymentSplitDtoV2';
import {
    PaymentSplitDtoV2FromJSON,
    PaymentSplitDtoV2FromJSONTyped,
    PaymentSplitDtoV2ToJSON,
    PaymentSplitDtoV2ToJSONTyped,
} from './PaymentSplitDtoV2';
import type { InitiateUnintegratedPaymentV2Request } from './InitiateUnintegratedPaymentV2Request';
import {
    InitiateUnintegratedPaymentV2RequestFromJSON,
    InitiateUnintegratedPaymentV2RequestFromJSONTyped,
    InitiateUnintegratedPaymentV2RequestToJSON,
    InitiateUnintegratedPaymentV2RequestToJSONTyped,
} from './InitiateUnintegratedPaymentV2Request';

/**
 * 
 * @export
 * @interface Invoice
 */
export interface Invoice extends InitiateUnintegratedPaymentV2Request {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Invoice
     */
    unintegratedFields?: { [key: string]: string; };
}



/**
 * Check if a given object implements the Invoice interface.
 */
export function instanceOfInvoice(value: object): value is Invoice {
    return true;
}

export function InvoiceFromJSON(json: any): Invoice {
    return InvoiceFromJSONTyped(json, false);
}

export function InvoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Invoice {
    if (json == null) {
        return json;
    }
    return {
        ...InitiateUnintegratedPaymentV2RequestFromJSONTyped(json, true),
        'unintegratedFields': json['unintegratedFields'] == null ? undefined : json['unintegratedFields'],
    };
}

export function InvoiceToJSON(json: any): Invoice {
    return InvoiceToJSONTyped(json, false);
}

export function InvoiceToJSONTyped(value?: Invoice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...InitiateUnintegratedPaymentV2RequestToJSONTyped(value, true),
        'unintegratedFields': value['unintegratedFields'],
    };
}

